import 'bootstrap-icons/font/bootstrap-icons.css'
import './SimpleAudio.scss'

import { useEffect } from 'react'
import { useAudio } from 'react-use'
import {
  UPDATE_AUDIO,
  UPDATE_AUDIO_CONTROLS,
  UPDATE_AUDIO_OPTIONS,
  usePlayer
} from '../../context/player-context'
import { useLocation } from 'react-router-dom'
import { UPDATE_TOTAL_TIME } from '../../../../common/components/CustomAudioPlayer/context/player-context'

export default function SimpleAudio() {
  let location = useLocation()
  const { dispatch } = usePlayer()

  const [audio, state, controls] = useAudio({
    src: location.state.sound,
    autoPlay: true
  })

  useEffect(() => {
    if (state.buffered.length > 0 && audio) {
      dispatch({ type: UPDATE_AUDIO_OPTIONS, payload: state })
      dispatch({ type: UPDATE_AUDIO_CONTROLS, payload: controls })
      dispatch({ type: UPDATE_AUDIO, payload: audio })
      dispatch({
        type: UPDATE_TOTAL_TIME,
        payload: location.state.duration
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  return <div className='simple-audio'>{audio}</div>
}
